import { Layout } from '@wix/design-system';
import React from 'react';
import { TLD_OFFERS_COLUMNS } from '../tldOfferWidget.constants';
export const TldOfferGrid = _ref => {
  let children = _ref.children;
  return /*#__PURE__*/React.createElement(Layout, {
    cols: TLD_OFFERS_COLUMNS,
    gap: "18px 16px"
  }, children);
};
//# sourceMappingURL=TldOfferGrid.js.map